import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders } from "../user/user.api";
import { PaginationResults, TypeQuery } from "../user/user.type";
import { BlanchisserieFormdata, IBlanchisserie } from "./blanchisserie.type";
import { ApiBaseUrl } from "../../http";
import { QueryUrl } from "../../Utils";
import { DesignationFormdata } from "../designation/designation.type";
import { ICity } from '../logement/logement.type';


const BlanchisserieApi = createApi({
  reducerPath: "blanchisserieApi",
  tagTypes: ["blanchisserie", "ville"],
  baseQuery: fetchBaseQuery({
    baseUrl: `${ApiBaseUrl}/api/`,
    prepareHeaders,
  }),
  endpoints: (build) => ({
    addBlanchisserie: build.mutation<IBlanchisserie,{ slug?: string; data: IBlanchisserie }>({
      query: ({ slug, data }) => ({
        url: slug ? `pricing/${slug}/` : `pricing/`,
        method: slug ? "PUT" : "POST",
        body: data,
      }),
      invalidatesTags: ["blanchisserie"],
    }),
    getBlanchisseries: build.query<PaginationResults<IBlanchisserie>, TypeQuery>({
      query: (query) => QueryUrl("pricing", query),
      providesTags: ["blanchisserie"],
    }),
    deleteBlanchisserie: build.mutation<BlanchisserieFormdata, string>({
      query: (slug) => ({
        url: `pricing/${slug}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["blanchisserie"],
    }),
    deleteDesignation: build.mutation<DesignationFormdata, string>({
      query: (slug) => ({
        url: `designations/${slug}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["blanchisserie"],
    }),
    getPricingVilles: build.query<ICity[], TypeQuery>({
      query: (query) => QueryUrl("pricing_villes", query),
      providesTags: ["ville"],
  }),
  }),
});

export default BlanchisserieApi

export const {
  useAddBlanchisserieMutation,
  useGetBlanchisseriesQuery,
  useDeleteBlanchisserieMutation,
  useDeleteDesignationMutation,
  useGetPricingVillesQuery
} = BlanchisserieApi;